
import store_consultation from '@/store/mods/consultations/consultations'
import ConsultationsMedecin from '../consultations-medecin'
import RendezVousMedecin from '../rendez-vous-medecin'
import calendar from '@/utils/clinic-calendar'

const dateLocale = date => calendar.day(date, 'UTC')

export default {
    name: 'activite-medecin',
    components: { ConsultationsMedecin, RendezVousMedecin },
    // kine : cartes du tableau Kiné (séances du jour, patients en rééducation) pour un médecin suivi par séances
    props: {
        mode_infirmier: { type: Boolean, default: false },
        mode_sage_femme: { type: Boolean, default: false },
        tableau_api: { type: Object, default: () => store_consultation },
        kine: { type: Object, default: null }
    },
    data() {
        const date = dateLocale(new Date())
        return {
            mois: date.slice(0, 7), mois_manuel: false,
            date_rdv: date, date_rdv_manuelle: false,
            rdv_total: null, rdv_sequence: 0, rdv_timer: null,   // RDV-003 : rendez-vous actifs de la date choisie
            annee_menu: Number(date.slice(0, 4)),
            liste_mois: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            mois_charge: '', statistiques: null, is_loading: false, rafraichissement_discret: false, erreur: '', sequence: 0,
            est_detruit: false, refresh_timer: null, popup_ouvert: false, detail: null, onglet_detail: 'specialites',
            cartes: this.mode_infirmier ? [
                { id: 'waiting', nom: 'En attente', scope: 'waiting', period: '' },
                { id: 'started_today', nom: 'Aujourd’hui', scope: 'started_today', period: 'today' },
                { id: 'started_month', nom: 'Ce mois', scope: 'started_month', period: 'month' },
                { id: 'appointments', nom: 'Rendez-vous', scope: 'appointments', period: 'date' }
            ] : [
                { id: 'closed_today', nom: 'Clôturées aujourd’hui', scope: 'closed', period: 'today' },
                { id: 'closed_month', nom: 'Clôturées ce mois', scope: 'closed', period: 'month' },
                { id: 'appointments', nom: 'Rendez-vous', scope: 'appointments', period: 'date' }
            ]
        }
    },
    watch: {
        // RDV-003 : la date choisie recharge le total, sans ouvrir la fenêtre
        date_rdv() {
            clearTimeout(this.rdv_timer)
            this.rdv_timer = setTimeout(() => { this.rdv_timer = null; this.charger_rendez_vous() }, 250)
        }
    },
    computed: {
        // Carte du médecin : « Mes stats » (au-dessus de Consultations et de Mes rendez-vous) ; infirmier : tous les médecins
        titre() { return this.mode_infirmier ? 'Statistiques' : 'Mes stats' },
        chargement_visible() { return this.is_loading && !this.rafraichissement_discret },
        repartition_specialites() {
            const groupes = {}
            ;(this.detail && this.detail.repartition || []).forEach(row => {
                const id = row.type_consultation_id
                if (!groupes[id]) groupes[id] = { nom: row.type_consultation, total: 0 }
                groupes[id].total += Number(row.total)
            })
            return Object.values(groupes)
        },
        repartition_specialistes() {
            const groupes = {}
            ;(this.detail && this.detail.repartition || []).forEach(row => {
                const nom = row.medecin_nom || 'Non attribué'
                const cle = String(row.doctor_id || 0) + '-' + nom
                if (!groupes[cle]) groupes[cle] = { nom, total: 0, specialites: [] }
                groupes[cle].total += Number(row.total) || 0
                if (row.type_consultation) groupes[cle].specialites.push(row.type_consultation)
            })
            return Object.values(groupes)
        },
        libelle_mois() { return (this.liste_mois[Number(this.mois.slice(5)) - 1] || 'Choisir un mois') + ' ' + this.mois.slice(0, 4) },
        date_rdv_valide() {
            if (!/^\d{4}-\d{2}-\d{2}$/.test(this.date_rdv)) return false
            const date = new Date(this.date_rdv + 'T12:00:00Z')
            return !isNaN(date.getTime()) && date.getUTCFullYear() > 0 && dateLocale(date) === this.date_rdv
        }
    },
    mounted() {
        this.charger_statistiques()
        this.charger_rendez_vous()
        if (typeof window !== 'undefined') {
            window.addEventListener('focus', this.actualiser)
            window.addEventListener('clinicaa:consultation-updated', this.actualiser)
        }
        this.refresh_timer = setInterval(() => {
            if (typeof document === 'undefined' || !document.hidden) this.actualiser()
        }, 60000)
    },
    activated() { this.actualiser() },
    beforeDestroy() {
        this.est_detruit = true
        this.sequence++
        clearInterval(this.refresh_timer)
        clearTimeout(this.rdv_timer)
        this.refresh_timer = null
        if (typeof window !== 'undefined') {
            window.removeEventListener('focus', this.actualiser)
            window.removeEventListener('clinicaa:consultation-updated', this.actualiser)
        }
    },
    methods: {
        carte_desactivee(id) {
            return id === 'appointments' ? !this.date_rdv_valide : (this.chargement_visible || !this.mois)
        },
        activer_carte(id) {
            if (this.carte_desactivee(id)) return
            this.ouvrir_details(id)
        },
        choisir_mois(numero) {
            const annee = Number(this.annee_menu)
            if (!Number.isInteger(annee) || annee < 1 || annee > 9999 || !Number.isInteger(numero) || numero < 1 || numero > 12) return
            this.mois = String(annee).padStart(4, '0') + '-' + String(numero).padStart(2, '0')
            this.mois_manuel = true
            return this.charger_statistiques()
        },
        deplacer_date_rdv(delta) {
            if (!this.date_rdv_valide || ![-1, 1].includes(delta)) return
            const date = new Date(this.date_rdv + 'T12:00:00Z')
            date.setUTCDate(date.getUTCDate() + delta)
            if (date.getUTCFullYear() > 0 && date.getUTCFullYear() <= 9999) {
                this.date_rdv = dateLocale(date)
                this.date_rdv_manuelle = true
            }
        },
        actualiser(event) {
            this.charger_rendez_vous()
            if (!this.is_loading || (event && event.type === 'clinicaa:consultation-updated')) return this.charger_statistiques(true)
        },
        async charger_statistiques(discret = false) {
            if (this.est_detruit) return
            const sequence = ++this.sequence
            const month = this.mois
            if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(month)) {
                this.erreur = 'Choisissez un mois et une année.'
                this.is_loading = false
                return
            }
            this.is_loading = true
            this.rafraichissement_discret = discret === true && !!this.statistiques && this.mois_charge === month
            this.erreur = ''
            try {
                const credential = await (this.mode_infirmier ? (this.tableau_api || store_consultation).getTableauInfirmierAccess() : (this.tableau_api || store_consultation).getTableauMedecinAccess())
                if (this.est_detruit || sequence !== this.sequence) return
                if (!credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès indisponible')
                // With no explicit choice, let the server select the clinic's current month.
                const payload = { access_token: credential.data.access_token }
                if (this.mois_manuel) payload.month = month
                const response = await (this.mode_infirmier ? (this.tableau_api || store_consultation).getStatistiquesTableauInfirmier(payload) : (this.tableau_api || store_consultation).getStatistiquesTableauMedecin(payload))
                if (this.est_detruit || sequence !== this.sequence) return
                const champs_requis = this.mode_infirmier ? ['waiting', 'started_today', 'started_month'] : ['waiting', 'ongoing', 'closed_today', 'closed_month']
                if (!response || champs_requis.some(id => response[id] === null || response[id] === '' || response[id] === undefined || !Number.isInteger(Number(response[id])) || Number(response[id]) < 0)) throw new Error('Statistiques indisponibles')
                const today = /^\d{4}-\d{2}-\d{2}$/.test(response.today) ? response.today : calendar.day(new Date(), response.timezone)
                const effectiveMonth = /^\d{4}-(0[1-9]|1[0-2])$/.test(response.month) ? response.month : this.mois_manuel ? month : today.slice(0, 7)
                if (this.mois_manuel && effectiveMonth !== month) throw new Error('Période inattendue')
                if (this.mode_infirmier) {
                    const annuaire = credential.data.medecins || []
                    ;['breakdown_today', 'breakdown_month', 'breakdown_started_today', 'breakdown_started_month'].forEach(key => {
                        response[key] = (response[key] || []).map(ligne => {
                            const identite = annuaire.find(personne => Number(personne.id) === Number(ligne.doctor_id))
                            return Object.assign({}, ligne, { medecin_nom: ligne.medecin_nom || identite && identite.nom })
                        })
                    })
                }
                this.statistiques = response
                if (this.popup_ouvert && this.detail && this.detail.scope === 'waiting') {
                    this.detail = Object.assign({}, this.detail, this.indicateurs_attente(response), { total: response.waiting })
                }
                this.mois = effectiveMonth
                this.mois_charge = effectiveMonth
                if (!this.mois_manuel) this.annee_menu = Number(effectiveMonth.slice(0, 4))
                if (!this.date_rdv_manuelle) this.date_rdv = today
            } catch (error) {
                if (!this.est_detruit && sequence === this.sequence) {
                    this.erreur = 'Impossible de charger votre activité. Actualisez pour réessayer.'
                    if (this.mode_sage_femme) this.statistiques = null
                }
            } finally {
                if (!this.est_detruit && sequence === this.sequence) this.is_loading = false
            }
        },
        // RDV-003 : total des rendez-vous planifiés de la date choisie (médecin connecté ; tous les médecins pour l'infirmier)
        async charger_rendez_vous() {
            if (this.est_detruit || !this.date_rdv_valide) { this.rdv_total = null; return }
            const sequence = ++this.rdv_sequence
            const date = this.date_rdv
            try {
                const credential = await (this.mode_infirmier ? (this.tableau_api || store_consultation).getTableauInfirmierAccess() : (this.tableau_api || store_consultation).getTableauMedecinAccess())
                if (this.est_detruit || sequence !== this.rdv_sequence) return
                if (!credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès indisponible')
                // RDV-006 : période explicite « jour » ; le médecin ne reçoit que ses propres rendez-vous (plus de périmètre)
                const payload = { periode: 'jour', date, page: 1, access_token: credential.data.access_token }
                const response = await (this.mode_infirmier ? (this.tableau_api || store_consultation).getRendezVousInfirmier(payload) : (this.tableau_api || store_consultation).getRendezVousMedecin(payload))
                if (this.est_detruit || sequence !== this.rdv_sequence) return
                if (!response || !response.counts || !Number.isInteger(Number(response.counts.actifs)) || Number(response.counts.actifs) < 0) throw new Error('Rendez-vous indisponibles')
                this.rdv_total = Number(response.counts.actifs)
            } catch (error) {
                if (!this.est_detruit && sequence === this.rdv_sequence) this.rdv_total = null
            }
        },
        valeur(id) {
            if (id === 'appointments') return this.rdv_total === null ? '—' : this.rdv_total
            if (id === 'closed_today' && this.kine && this.kine.seances_aujourdhui) {
                return this.kine.seances_aujourdhui.faites + ' / ' + this.kine.seances_aujourdhui.prevues
            }
            return this.statistiques && this.mois_charge === this.mois ? this.statistiques[id] : '—'
        },
        duree_attente(secondes) {
            return secondes === null || secondes === undefined ? '—' : calendar.duration(secondes)
        },
        indicateurs_attente(stats) {
            return {
                waiting_female: stats.waiting_female,
                waiting_male: stats.waiting_male,
                waiting_unknown_sex: stats.waiting_unknown_sex,
                waiting_total_seconds: stats.waiting_total_seconds,
                waiting_average_seconds: stats.waiting_average_seconds
            }
        },
        choisir_onglet(onglet) { this.onglet_detail = onglet },
        ouvrir_details(id) {
            const carte = this.cartes.find(item => item.id === id)
            this.onglet_detail = id === 'waiting' ? 'patients' : 'specialites'
            if (carte && id === 'appointments') {
                if (!this.date_rdv_valide) return
                this.detail = Object.assign({}, carte, { date: this.date_rdv })
                this.popup_ouvert = true
                return
            }
            if (!carte || !/^\d{4}-(0[1-9]|1[0-2])$/.test(this.mois)) return
            this.detail = Object.assign({}, carte, { month: this.mois })
            if (this.mode_infirmier) {
                if (!this.statistiques || this.mois_charge !== this.mois) return
                const period = carte.period
                this.detail = Object.assign({}, this.detail, {
                    repartition: this.statistiques['breakdown_started_' + period] || [],
                    patients: this.statistiques['patient_count_started_' + period] || 0,
                    medecins: this.statistiques['doctor_count_started_' + period] || 0,
                    total: this.statistiques[carte.id]
                }, this.indicateurs_attente(this.statistiques))
            }
            this.popup_ouvert = true
        }
    }
}
